module.exports = __webpack_public_path__ + "assets/img/图标／68px@2x(4).d1da8c48.png";